import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/governance-council/page.tsx");
